import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const KEY = 'sf-vehicle';
const read = () => { try { return JSON.parse(window.localStorage.getItem(KEY)) || null; } catch (e) { return null; } };
const Ctx = createContext(null);

export const VehicleProvider = ({ children }) => {
  const [vehicle, setV] = useState(read);
  const setVehicle = useCallback((v) => { setV(v); try { if (v) window.localStorage.setItem(KEY, JSON.stringify(v)); else window.localStorage.removeItem(KEY); } catch (e) { /* ignore */ } }, []);
  const clearVehicle = useCallback(() => setVehicle(null), [setVehicle]);
  const value = useMemo(() => ({ vehicle, setVehicle, clearVehicle }), [vehicle, setVehicle, clearVehicle]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};
export const useVehicle = () => useContext(Ctx) || { vehicle: null, setVehicle: () => {}, clearVehicle: () => {} };
